import React, { Component } from 'react';
import classes from './mfaStatus.scss';
import ToggleMFAStatus from './toggleMFAStatus';
import TurnOnMFAContainer from '../../../Centralized/common/MFA/TurnOnMFA/TurnOnMFAContainer';
import LoginMFAContainer from '../../../Centralized/common/MFA/LoginMFA/loginMFAContainer';
import { getLocalizedStrings } from  '../../../Centralized/common/MFA/mfaPageLocalizedStrings';

class MFAStatus extends Component {
  constructor(props) {
    super(props);
    this.state = {
      isMFAOn: false,
      isToggleMFAOpen: false,
      isTurnOnMFAOpen: false,
      userLoginInfoDetails: {},
      showTurnOffDialog: false,
      isEditingNumber: false,
      newNumber: ''

    };
    this.inputRef = React.createRef();
    this.strings = getLocalizedStrings('MFAStatusCard');
  }
  componentDidMount() {

    const userLoginInfoDetails = JSON.parse(app.appService.getLocalStorage('mfaInfo')) || {};
    this.setState({
      userLoginInfoDetails,
      isMFAOn: userLoginInfoDetails.eixSCEMFAStatus === 'Enrolled'
    });

  }
  componentDidUpdate() {
    const userLoginInfoDetails = JSON.parse(app.appService.getLocalStorage('mfaInfo')) || {};

    if (JSON.stringify(userLoginInfoDetails) !== JSON.stringify(this.state.userLoginInfoDetails)) {
      this.setState({
        userLoginInfoDetails,
        isMFAOn: userLoginInfoDetails.eixSCEMFAStatus === 'Enrolled'
      });
    }
  }
    editBtnClickHandler = () => {
      this.setState({
        isToggleMFAOpen: true,
        isTurnOnMFAOpen: false,
        isTurnOffMFAOpen: false,
        showTurnOffDialog: false,
        isEditingNumber: false,
        isAddingNewNumber: false,
        newNumber: ''
      });
    }
    handleToggleButtonClick = () => {
      const { isMFAOn } = this.state;
      if (isMFAOn) {
        this.setState({
          showTurnOffDialog: true,
        });
        return;
      }
      this.setState({
        isTurnOnMFAOpen: true,
        isToggleMFAOpen: false
      });
    }
   

    handleTurnOffMFAClick = () => {
      this.setState({
        isToggleMFAOpen: false,
        isTurnOnMFAOpen: false,
        isTurnOffMFAOpen: true
      });
    }
    mfaNumberEditBtnHandler = () => {
      const { isEditingNumber } = this.state;
      if (isEditingNumber) { //for submiting new phone number
        this.setState({
          isAddingNewNumber: true,
          isToggleMFAOpen: false
        });
        return ;
      }
      this.inputRef.current.focus();
      this.setState({ isEditingNumber: true });
    }

    render() {
      const { isMFAOn,
        isToggleMFAOpen,
        isTurnOnMFAOpen,
        userLoginInfoDetails,
        showTurnOffDialog,
        isTurnOffMFAOpen,
        isEditingNumber,
        newNumber,
        isAddingNewNumber
      } = this.state;
      const { emailId = '', maskedValue: mfaPhoneNumber = '' } = userLoginInfoDetails;
      return <div className={classes.Card}>
        <div className={classes.mfaCardContent}>
          <div >
            <div className={classes.nameLabel}>{this.strings.verification}</div>
            <div className={classes.nameContent}>{this.strings.content}</div>
            <div className={classes.nameLabel}>{this.strings.status}{isMFAOn ? this.strings.on : this.strings.off}</div>
          </div>
          <div className={classes.mfaButtonPadding}>
            <button className={classes.editButton} id='name' onClick={this.editBtnClickHandler} >{this.strings.edit}</button>
          </div>

        </div>


        {isToggleMFAOpen &&
        <ToggleMFAStatus
          onClose={() => this.setState({ isToggleMFAOpen: false })}
          isMFAOn={isMFAOn}
          handleToggleButtonClick={this.handleToggleButtonClick}
          emailId={emailId}
          mfaPhoneNumber={mfaPhoneNumber}
          showTurnOffDialog={showTurnOffDialog}
          handleTurnOffDialogCancel={this.editBtnClickHandler}
          handleTurnOffMFAClick={this.handleTurnOffMFAClick}
          mfaNumberEditBtnHandler={this.mfaNumberEditBtnHandler}
          isEditingNumber={isEditingNumber}
          newNumber={newNumber}
          handlePhoneNumberChange={(e) => {
            const value = e.target.value.replace(/\D/g, '');
            this.setState({ newNumber: value });
          }}
          inputRef={this.inputRef}

        />}
        {isTurnOnMFAOpen && <TurnOnMFAContainer
          onClose={() => this.setState({ isTurnOnMFAOpen: false })}
          onReopenParentPopup={this.editBtnClickHandler}
          fromProfile
        />}
        {(isTurnOffMFAOpen || isAddingNewNumber) && <LoginMFAContainer
          onClose={() => this.setState({ isTurnOffMFAOpen: false, isAddingNewNumber: false })}
          onReopenParentPopup={this.editBtnClickHandler}
          fromProfile
          isAddingNewNumber={isAddingNewNumber}
          newNumber={newNumber}
        />}
      </div>;
    }
}

export default MFAStatus;